<template>
  <TabPane :label="tabLabel" :name="tabName">
    <v-loading :loading="loading"></v-loading>
    <div class="paymentc__main" @scroll="handleContractScroll">
      <div class="paymentc__filter">
        <Row :gutter="16">
          <Col span="6">
            <span class="label">{{filterLabel}}:</span>
            <Select :value="searchParams.status"
                    v-if="isBalance"
                    :placeholder="filterLabel"
                    @on-change="val => handleFilter(val, 'status')"
                    transfer>
              <Option value="all">{{'不限'}}</Option>
              <Option value="TOPAID">{{'待支付'}}</Option>
              <Option value="PAID">{{'已支付'}}</Option>
            </Select>
            <Select :value="searchParams.status"
                    v-else
                    :placeholder="filterLabel"
                    @on-change="val => handleFilter(val, 'status')"
                    transfer>
              <Option value="all">{{'不限'}}</Option>
              <Option value="TOPAID">{{'待支付'}}</Option>
              <Option value="PAID">{{'已支付'}}</Option>
              <Option value="OVERDUE">{{'已逾期'}}</Option>
            </Select>
          </Col>
          <Col span="18">
            <Input prefix="ios-search"
                   v-model="searchParams.keyWord"
                   @on-enter="handleFilter()"
                   :placeholder="isBalance ? '客户用户名、订单编号' : '公司信息、账单编号、合同编号'"/>
          </Col>
        </Row>
      </div>
      <ul class="paymentc__body" v-if="dataList.length">
        <PaymentItem
          v-for="(item, index) in dataList"
          :key="itemKey(item)"
          :item="item"
          :originItem="originDataList[index]"
          :editable="editable"
          @on-update-item="handleUpdateItem"
          @on-update-item-remark="handleUpdateItemRemark"
          @on-remark-show="handleShowRemark(index)"
          @on-detail-show="handleShowDetail"
          @on-loading="updateLoading"
          :isBalance="isBalance"></PaymentItem>
      </ul>
      <div class="paymentc__body no-data" v-else>
        <v-no-data type="whole"
                   v-if="isBalance"
                   icon="iconreceipt_long-24px"
                   title="暂无余额订单"
                   subtitle=""
        ></v-no-data>
        <v-no-data type="whole"
                   v-else
                   icon="iconreceipt_long-24px"
                   title="暂无月账单"
                   subtitle=""
        ></v-no-data>
      </div>
    </div>
    <PaymentRemark v-if="editable" :visible.sync="remarkVisible"
                   @on-save-remark="handleSaveRemark"
    ></PaymentRemark>
    <contractDetail :visible.sync="detailVisible"
                    :contractStatusMap="contractStatusMap"
                    :contractTypeMap="contractTypeMap"
                    :selection="detailSelection"></contractDetail>
  </TabPane>
</template>

<script>
import {
  getRechargeList,
  getBillingList,
  updateJournal,
  updateBilling,
} from '@/api/settlement/payment';
import { contractStatusMap, contractTypeMap } from '@/config/enum.config';
import PaymentItem from './paymentItem.vue';
import PaymentRemark from './remark.vue';
import contractDetail from '@/views/settlement/contract/contractDetail.vue';

export default {
  name: 'paymentTab',
  components: {
    PaymentItem,
    PaymentRemark,
    contractDetail,
  },
  props: {
    type: String,
    selectTabName: String,
    flagList: {
      type: Array,
      default() {
        return [];
      },
    },
    editable: Boolean,
    users: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      searchParams: {
        keyWord: '',
        status: 'all',
      },
      pageSize: 10,
      pageNum: 1,
      total: 0,
      loading: false,
      dataList: [],
      originDataList: [],
      selectionIndex: null,
      remarkVisible: false,
      detailVisible: false,
      detailSelection: {},
      contractStatusMap,
      contractTypeMap,
    };
  },
  computed: {
    isBalance() {
      return this.type === 'balance';
    },
    tabLabel() {
      return this.isBalance ? '余额充值订单' : '服务购买月账单';
    },
    tabName() {
      return this.isBalance ? '0' : '1';
    },
    filterLabel() {
      return this.isBalance ? '订单状态' : '账单状态';
    },
  },
  watch: {
    flagList(val) {
      if (val.length) {
        val.forEach((item) => {
          const index = this.dataList.findIndex((i) => i.id === item.id);
          if (index > -1) {
            this.dataList.splice(index, 1, {
              ...this.dataList[index],
              isChanged: false,
              pay_flag: item.pay_flag,
            });
            this.originDataList = JSON.parse(JSON.stringify(this.dataList));
          }
        });
      }
    },
    users(val) {
      if (val && val.length) {
        this.dataList = [];
        this.originDataList = [];
        this.getPaymentList();
      }
    }
  },
  created() {
    this.getPaymentList();
  },
  methods: {
    async getPaymentList(isSearch) {
      const { status, keyWord } = this.searchParams;
      this.loading = true;
      this.updateLoading(true);
      const data = {
        journal_status: status === 'all' ? undefined : status,
        user_parameter: keyWord,
        page_size: this.pageSize,
        page_num: this.pageNum,
        user_id_list: this.users.join(',')
      };
      if (this.isBalance) {
        data.journal_status = status === 'all' ? undefined : status;
      } else {
        data.billing_status = status === 'all' ? undefined : status;
      }
      const res = this.isBalance ? await getRechargeList(data) : await getBillingList(data);
      if (res) {
        if (isSearch) {
          this.dataList = res.data_list;
          this.originDataList = res.data_list;
        } else {
          this.dataList.push(...res.data_list);
          this.originDataList.push(...res.data_list);
        }
        this.total = res.total;
      } else if (isSearch) {
        this.dataList = [];
        this.originDataList = [];
      }
      this.loading = false;
      this.updateLoading(false);
    },
    handleFilter(val, name) {
      if (val) {
        this.searchParams[name] = val;
      }
      this.pageNum = 1;
      this.getPaymentList(true);
    },
    handleContractScroll(e) {
      if (this.pageNum * this.pageSize < this.total && !this.loading) {
        const { scrollTop, clientHeight, scrollHeight } = e.target;
        if (scrollTop + clientHeight >= scrollHeight - 50) {
          this.pageNum += 1;
          this.getPaymentList();
        }
      }
    },
    handleUpdateItem(item) {
      const index = this.dataList.findIndex((i) => i.id === item.id);
      if (index > -1) {
        let isChanged = item.journal_status !== this.originDataList[index].journal_status;
        if (!this.isBalance) {
          isChanged = item.billing_status !== this.originDataList[index].billing_status;
        }
        this.dataList.splice(index, 1, {
          ...item,
          isChanged,
        });
        this.$emit('on-update-item', this.dataList[index], isChanged);
      }
    },
    handleUpdateItemRemark(item) {
      const index = this.dataList.findIndex((i) => i.id === item.id);
      this.dataList.splice(index, 1, item);
    },
    handleShowRemark(index) {
      this.selectionIndex = index;
      this.remarkVisible = true;
    },
    async handleSaveRemark(remark) {
      this.updateLoading(true);
      let res = false;
      if (this.isBalance) {
        res = await updateJournal([{
          id: this.dataList[this.selectionIndex].id,
          comment: remark,
        }]);
      } else {
        res = await updateBilling([{
          id: this.dataList[this.selectionIndex].id,
          comment: remark,
        }]);
      }
      this.updateLoading(false);
      if (res) {
        this.$Message.success('操作成功');
        this.remarkVisible = false;
        this.handleUpdateItemRemark({
          ...this.dataList[this.selectionIndex],
          comment: remark,
        });
      }
    },
    updateLoading(value) {
      this.$emit('on-loading', value);
    },
    handleShowDetail(item) {
      this.detailVisible = true;
      this.detailSelection = {
        ...item,
        status: item.billing_status,
        system_contract_number: item.contract_number,
      };
    },
    itemKey(item) {
      const {
        id, comment, pay_flag,
      } = item;
      let result = Math.random().toString(16).slice(2) + id + comment + pay_flag;
      if (this.isBalance) {
        result += item.journal_status;
      } else {
        result += item.billing_status;
      }
      return result;
    },
  },
};
</script>

<style lang="less">

</style>
